import MatterStatusesSettingsView from "@/components/features/settings/defaults/matter-statuses/MatterStatusesSettingsView";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { INTAKE_STATUS_CATEGORY_OPTIONS } from "@/lib/data/static/matterStatics";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/intake/statuses")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.intakeSettingsStatuses)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <MatterStatusesSettingsView
      title="Intake statuses"
      addButtonLabel="Add intake status"
      categoryOptions={INTAKE_STATUS_CATEGORY_OPTIONS}
    />
  );
}
